// libraries
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import { ToggleGroup } from '@interstate/components/ToggleGroup/ToggleGroup/ToggleGroup';

// components
import FieldOverrideIndicator from './FieldOverrideIndicator.interstate';

// hooks
import type { ResidualFieldConfig } from './hooks/useResidualField';
import { useResidualField } from './hooks/useResidualField';

// styles
import {
    StyledTextWithToggleGroupContainer,
    StyledTextWithToggleGroupText,
    StyledTextWithToggleGroupToggleCompact
} from './StyledTextWithToggleGroup.styles';

const ResidualField = (props: ResidualFieldConfig) => {
    const { label, isReadOnlyForOpenGrid, overrideIndicatorProps, valueInputProps, unitToggleProps } = useResidualField(props);

    return (
        <StyledTextWithToggleGroupContainer>
            <StyledTextWithToggleGroupText className="residual-field-container" $isReadOnly={isReadOnlyForOpenGrid}>
                <FieldOverrideIndicator {...overrideIndicatorProps}>
                    <NumericInput {...valueInputProps} label={label} />
                </FieldOverrideIndicator>
            </StyledTextWithToggleGroupText>
            {!isReadOnlyForOpenGrid && (
                <StyledTextWithToggleGroupToggleCompact>
                    <ToggleGroup {...unitToggleProps} />
                </StyledTextWithToggleGroupToggleCompact>
            )}
        </StyledTextWithToggleGroupContainer>
    );
};

export default ResidualField;
